var _ = require('lodash');
var PIXI = require('pixi.js');

var _textures = {};
var _sprites = {};

function clearTextures(keys) {
    // console.log('clear sprites', _sprites);
    Object.keys(_sprites).forEach((sprite) => {
        if (keys.indexOf(sprite) === -1) {
            _sprites[sprite] = null;
        }
    });

    Object.keys(_textures).forEach((texture) => {
        // console.log(texture);
        if (keys.indexOf(texture) === -1) {
            // console.log('not needed', texture)
            if (texture.match(/json$/)) {
                const jsonKey = `${texture}_image`;
                if (PIXI.utils.TextureCache[jsonKey]) {
                    PIXI.utils.TextureCache[jsonKey].destroy(true);
                }
            }

            if (PIXI.utils.TextureCache[texture]) {
                PIXI.utils.TextureCache[texture].destroy(true);
            }
            // console.log('texture', PIXI.utils.TextureCache[texture]);
            if (_textures[texture] !== null && typeof _textures[texture] === 'object') {
                _textures[texture].destroy();
                delete _textures[texture];
            } else {
                delete _textures[texture];
            }
        }
    });
}

function loadTextures(objects, progressCallback) {
    var allLoadedResolve;
    var willLoad = 0;
    var didLoad = 0;

    function getTexture(texture) {
        return _textures[texture];
    }

    function sendProgress() {
        if (_.isFunction(progressCallback)){
            progressCallback({
                progress: didLoad/willLoad,
                loaded: didLoad,
                total: willLoad
            });
        }
    }

    function done() {
        var newObjects = {};
        var object;
        var textures;
        var texture;
        var spriteKey, textureKey, spriteTextures, selectedTextures;

        sendProgress();

        for (var key in objects)
        {
            object = objects[key];
            if (_.isArray(object.texture)) {
                texture = object.texture;
                textures = _.map(object.texture, getTexture);
            } else {
                const spriteMatches = object.texture.match(/^sprite\:([^\,]+)\,?([^\,]+)?$/);
                if(spriteMatches) {
                    spriteKey = spriteMatches[1];
                    textureKey = spriteMatches[2];
                    if(textureKey) {
                        spriteTextures = _sprites[spriteKey];
                        selectedTextures = [];
                        for(var i = 0, sl = spriteTextures.length; i < sl; i++) {
                            if(spriteTextures[i].indexOf(textureKey) !== -1) {
                                selectedTextures.push(spriteTextures[i]);
                                texture = textureKey || _sprites[spriteKey];
                                textures = textureKey ? _textures[textureKey] : _sprites[spriteKey].map(getTexture);
                            }
                        }
                        texture = selectedTextures.length === 1 ? selectedTextures[0] : selectedTextures;
                        textures = selectedTextures.length === 1 ? _textures[selectedTextures[0]] : selectedTextures.map(getTexture);
                    } else {
                        texture = _sprites[spriteKey];
                        textures = _sprites[spriteKey].map(getTexture);
                    }

                } else {
                    texture = object.texture;
                    textures = _textures[object.texture];
                }
            }

            newObjects[key] = _.extend({}, object, {
                src: texture,
                texture: textures
            });
        }

        allLoadedResolve(newObjects);
    }

    const loader = new PIXI.loaders.Loader();
    loader.on('load', (loader, resource) => {
        if (_sprites[resource.name]) {
            var texture;
            var frameKey;
            var newSprites = [];
            for (frameKey in resource.data.frames) {
                _textures[frameKey] = PIXI.Texture.fromFrame(frameKey);
                newSprites.push(frameKey);
            }
            _sprites[resource.name] = newSprites;
            didLoad++;
        } else if(!resource.name.match(/json\_image$/)) {
            _textures[resource.name] = resource.texture;
            didLoad++;
        }

        if (willLoad === didLoad) {
            done();
        } else {
            sendProgress();
        }
    });

    return new Promise(function(resolve, reject) {
        allLoadedResolve = resolve;

        var object;
        var textures;
        var texture;
        var src;
        var spriteMatches;
        for (var key in objects)
        {
            object = objects[key];
            textures = _.isArray(object.texture) ? object.texture:[object.texture];

            for (var i = 0, tl = textures.length; i < tl; i++)
            {
                texture = textures[i];

                spriteMatches = texture.match(/^sprite\:([^\,]+)\,?([^\,]+)?$/);
                if(spriteMatches) {
                    texture = spriteMatches[1];
                    if (!_sprites[texture]) {
                        _sprites[texture] = [];
                    }
                }
                if (!_textures[texture]) {
                    _textures[texture] = true;
                    var textureUrl = `${CDN}${texture}`;
                    loader.add({ name: texture, url: textureUrl, crossOrigin: CDN !== '' });
                    willLoad++;
                }
            }
        }

        if (willLoad === 0) {
            // console.log('done');
            done();
        } else {
            // console.log('load');
            loader.load();
        }
    });
};

const ex = {
    loadTextures,
    clearTextures,
};

module.exports = ex;

export default ex.loadTextures;



// WEBPACK FOOTER //
// ./js/lib/loadTextures.js